import PropTypes from 'prop-types'
import React from 'react'

import StoriesSlider from 'components/StoriesSlider'
import { LocalizationContext } from 'contexts/Localization'
import { ResizeContext } from 'contexts/Resize'

import StoriesFirstBlock from './components/StoriesFirstBlock'

const Stories = function({ texts, stories }) {
  const { mobile } = React.useContext(ResizeContext)
  const { paths, locale } = React.useContext(LocalizationContext)
  const secondBlockRef = React.useRef()
  const { description, title, subtitle, scroll_to_site } = texts.first

  return (
    <>
      <StoriesFirstBlock
        {...{
          description,
          title,
          subtitle,
          scroll_to_site,
          secondBlockRef,
        }}
      />

      <div className="pt-6" ref={secondBlockRef}>
        {stories && stories.list && (
          <StoriesSlider
            slides={stories.list}
            isMobile={mobile}
            path={paths.cdn_global}
            locale={locale}
          />
        )}
      </div>
    </>
  )
}

Stories.propTypes = {
  texts: PropTypes.object.isRequired,
  stories: PropTypes.object,
}

export default Stories
